import {
  generateStyleClasses,
  styleHelper,
} from "../../helpers/commonFunctions";
import { DiscountPillDataType } from "../../interfaces/discountPill/DiscountPill.type";
import styles from "./Discount.module.css";

import { useState, useEffect } from "react";

export default function Discount({ item }: { item: DiscountPillDataType }) {
  const discountText = item?.discountText;
  const timePrefix = item?.timePrefix;
  const timer = item?.timer;
  const [countdown, setCountdown] = useState("00:00:00");
  useEffect(() => {
    const startTime = new Date().getTime(); // Replace with your actual start time
    const interval = setInterval(() => {
      const currentTime = new Date().getTime();
      const remainingTime =
        startTime +
        ((timer?.time ? timer?.time : 0) / 60) * 60 * 1000 -
        currentTime; // 30 minutes countdown
      const hours = Math.floor(
        (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
      setCountdown(
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`
      );
      if (remainingTime <= 0) {
        clearInterval(interval);
        setCountdown("00:00:00");
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timer.time]);

  return (
    <button
      className={`vas-btn vas-btn-sm vas-fs-4 vas-pe-none vas-border-radius`}
      style={styleHelper({
        backgroundColor: item?.backgroundColor,
        border: `1px solid ${item?.borderColor}`,
      })}
    >
      <span
        className={`${generateStyleClasses(discountText?.style)}`}
        style={styleHelper({ color: discountText?.textColor })}
      >
        {discountText?.text}
      </span>{" "}
      <span
        className={`${generateStyleClasses(timePrefix?.style)}`}
        style={styleHelper({ color: timePrefix?.textColor })}
      >
        {timePrefix?.text}
      </span>{" "}
      <span
        className={`${styles.timer} ${generateStyleClasses(timer?.style)}`}
        style={styleHelper({ color: timer?.textColor })}
      >
        {countdown}
      </span>
    </button>
  );
}
